export const SET_CLIENT_BALANCE = 'SET_CLIENT_BALANCE';
